document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav drawer
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeBtn = document.querySelector('[data-drawer-close]');
  var drawer = document.querySelector('[data-drawer]');
  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () { drawer.classList.add('is-open'); });
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', function () { drawer.classList.remove('is-open'); });
  }

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (main) { main.src = thumb.getAttribute('data-full'); }
    });
  });

  // Quantity steppers — also keep the Add to Cart button's price in sync
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var form = stepper.closest('form');
    var btn = form ? form.querySelector('[data-add-to-cart-btn]') : null;
    var priceEl = btn ? btn.querySelector('[data-add-to-cart-price]') : null;
    var unitPrice = btn ? parseInt(btn.getAttribute('data-unit-price'), 10) : null;
    var currency = btn ? btn.getAttribute('data-currency') : null;

    function formatMoney(cents) {
      var amount = cents / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
      } catch (e) {
        return '$' + amount.toFixed(2);
      }
    }

    function updatePrice() {
      if (!priceEl || !unitPrice) return;
      var qty = Math.max(1, parseInt(input.value, 10) || 1);
      priceEl.textContent = formatMoney(unitPrice * qty);
    }

    stepper.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        updatePrice();
      });
    });

    input.addEventListener('input', updatePrice);
    input.addEventListener('change', updatePrice);
  });

  // Shopify Variant Swatch Selection
document.querySelectorAll('[data-swatch-group]').forEach(function (group) {

  group.querySelectorAll('.swatch').forEach(function (swatch) {

    swatch.addEventListener('click', function () {

      // Remove selected state
      group.querySelectorAll('.swatch').forEach(function (s) {
        s.classList.remove('is-selected');
        s.setAttribute('aria-checked', 'false');
      });

      // Select clicked swatch
      swatch.classList.add('is-selected');
      swatch.setAttribute('aria-checked', 'true');

      // Get Shopify variant ID
      var variantId = swatch.dataset.variantId;

      if (!variantId) {
        console.warn('No variant ID found on swatch:', swatch);
        return;
      }

      // Find the Shopify product form
      var productForm =
        swatch.closest('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');

      if (!productForm) {
        console.warn('Shopify product form not found.');
        return;
      }

      // Find Shopify's variant ID input
      var variantInput = productForm.querySelector('[name="id"]');

      if (!variantInput) {
        console.warn('Variant ID input not found.');
        return;
      }

      // Update Shopify variant
      variantInput.value = variantId;

      // Fire events so other theme code knows variant changed
      variantInput.dispatchEvent(new Event('input', {
        bubbles: true
      }));

      variantInput.dispatchEvent(new Event('change', {
        bubbles: true
      }));

      // Update URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);

      console.log('Selected Shopify variant:', variantId);

    });

  });

});

  // Product carousels (featured collection slideshow)
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var section = carousel.closest('section') || carousel.parentElement;
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    if (!prevBtn || !nextBtn) return;

    function updateArrows() {
      var maxScroll = carousel.scrollWidth - carousel.clientWidth - 1;
      prevBtn.disabled = carousel.scrollLeft <= 0;
      nextBtn.disabled = carousel.scrollLeft >= maxScroll;
    }

    function getCardScrollAmount() {
      var item = carousel.querySelector('.product-carousel__item');
      if (!item) return carousel.clientWidth * 0.9;
      var track = carousel.querySelector('[data-carousel-track]');
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0);
      return item.getBoundingClientRect().width + gap;
    }

    function scrollByPage(direction) {
      carousel.scrollBy({ left: direction * getCardScrollAmount(), behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () { scrollByPage(-1); });
    nextBtn.addEventListener('click', function () { scrollByPage(1); });
    carousel.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
  
// Hero slideshow (crossfade between images)
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (frame) {
    var slides = frame.querySelectorAll('.hero-slide');
    if (slides.length < 2 || reduceMotion) return;

    var duration = parseInt(frame.getAttribute('data-duration'), 10) || 5000;
    var index = 0;

    setInterval(function () {
      var next = (index + 1) % slides.length;
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      index = next;
    }, duration);
  });

  // Quick add to cart (product cards) — adds without leaving the page
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      var label = btn.querySelector('[data-quick-add-label]');
      var originalText = label ? label.textContent : '';
      if (!variantId) return;

      btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (label) label.textContent = 'Added ✓';
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-added');
            if (label) label.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          if (label) label.textContent = 'Try again';
          btn.disabled = false;
        });
    });
  });
});